'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rafThrottle = require('../../../common/utils/lib/rafThrottle');

var _rafThrottle2 = _interopRequireDefault(_rafThrottle);

var _selectionUtils = require('../../element/selection/selectionUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/sort-comp */
// Lib


// Utils


/**
 * Attaches the DOM event listeners and invokes the state update methods as appropriate based on mouse moves.
 */
exports.default = function (DecoratedComponent) {
    var SelectionMarqueeEventHandler = function (_React$Component) {
        _inherits(SelectionMarqueeEventHandler, _React$Component);

        function SelectionMarqueeEventHandler(props) {
            _classCallCheck(this, SelectionMarqueeEventHandler);

            var _this = _possibleConstructorReturn(this, (SelectionMarqueeEventHandler.__proto__ || Object.getPrototypeOf(SelectionMarqueeEventHandler)).call(this, props));

            _initialiseProps.call(_this);

            _this.eventsAttached = false;
            return _this;
        }

        _createClass(SelectionMarqueeEventHandler, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                this.attachMarqueeSelectionStartListener(this.props);
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.attachMarqueeSelectionStartListener(this.props);
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                this.attachMarqueeSelectionStartListener(nextProps);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.removeEventListeners();
            } // eslint-disable-line react/sort-comp

        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(DecoratedComponent, this.props);
            }
        }]);

        return SelectionMarqueeEventHandler;
    }(_react2.default.Component);

    var _initialiseProps = function _initialiseProps() {
        var _this2 = this;

        this.attachMarqueeSelectionStartListener = function (props) {
            if (!props.eventListenerNode || _this2.eventsAttached) return;

            _this2.eventsAttached = true;

            props.eventListenerNode.addEventListener('mousedown', _this2.onMouseDown);
        };

        this.removeMarqueeSelectionStartListener = function () {
            _this2.props.eventListenerNode.removeEventListener('mousedown', _this2.onMouseDown);
        };

        this.attachMarqueeSelectionMoveListeners = function () {
            document.addEventListener('mousemove', _this2.throttledMouseMove);
            document.addEventListener('mouseup', _this2.onMouseUp);
        };

        this.removeMarqueeSelectionMoveListeners = function () {
            document.removeEventListener('mousemove', _this2.throttledMouseMove);
            document.removeEventListener('mouseup', _this2.onMouseUp);
        };

        this.removeEventListeners = function () {
            if (!_this2.props.eventListenerNode) return;
            _this2.eventsAttached = false;

            _this2.removeMarqueeSelectionStartListener();
            _this2.removeMarqueeSelectionMoveListeners();
        };

        this.onMouseDown = function (event) {
            var _props = _this2.props,
                startMarqueeSelect = _props.startMarqueeSelect,
                eventListenerNode = _props.eventListenerNode;


            if (event.target !== eventListenerNode || event.button !== 0) return;

            // Set focus to the document body so that keyboard shortcuts can be used again after interacting
            // with an iFrame
            window.focus();
            if (document.activeElement) document.activeElement.blur();

            event.preventDefault();
            _this2.attachMarqueeSelectionMoveListeners();

            var appendMode = (0, _selectionUtils.isAttemptingMultiSelect)(event);
            startMarqueeSelect(_extends({}, _this2.getPositionFromMouseEvent(event), { appendMode: appendMode }));
        };

        this.onMouseMove = function (event) {
            _this2.props.dragMarqueeSelectionTo(_this2.getPositionFromMouseEvent(event));
        };

        this.throttledMouseMove = (0, _rafThrottle2.default)(this.onMouseMove);

        this.onMouseUp = function (event) {
            _this2.throttledMouseMove.cancel();
            _this2.props.finishMarqueeSelect();
            _this2.removeMarqueeSelectionMoveListeners();
        };

        this.getPositionFromMouseEvent = function (event) {
            // We need to use the pageX/Y because the offsetX/Y changes based on the hovered element.  Because of this
            // we need to subtract the canvas's translation from the pageX/Y
            var eventListenerBoundingRect = _this2.props.eventListenerNode.getBoundingClientRect();

            return {
                x: event.pageX - eventListenerBoundingRect.left,
                y: event.pageY - eventListenerBoundingRect.top
            };
        };
    };

    SelectionMarqueeEventHandler.propTypes = {
        eventListenerNode: _propTypes2.default.object,
        startMarqueeSelect: _propTypes2.default.func,
        dragMarqueeSelectionTo: _propTypes2.default.func,
        finishMarqueeSelect: _propTypes2.default.func,
        deselectAll: _propTypes2.default.func
    };

    return SelectionMarqueeEventHandler;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/selection/selectionMarqueeMouseEventHandlerDecorator.js
// module id = 1696
// module chunks = 0